module.exports = __webpack_public_path__ + "img/FiAPC-probes.0abded42.png";